import { mdiMapMarker } from '@mdi/js'
import Icon from '@mdi/react'
import { locales } from '../../locales/en'

const MapMarker = (props) => (
    <Icon
        data-testid="IconButton__MapMarkerButton"
        title={locales.modelTile.location}
        path={mdiMapMarker}
        size={1}
        {...props}
    />
)

export default MapMarker
